import { useComputed } from "@preact/signals";

import { allJobs } from "../store/appStore";
import { Sparkline } from "./Sparkline";

/** Stats grid for Diagnostics overview — shows loaded dataset totals. */
export function StatsGrid({ compact = false }: { compact?: boolean }) {
  const total = useComputed(() => allJobs.value.length);
  const companies = useComputed(() => new Set(allJobs.value.map((j) => j.company)).size);
  const gh = useComputed(() => allJobs.value.filter((j) => j.ats === "greenhouse").length);
  const lv = useComputed(() => allJobs.value.filter((j) => j.ats === "lever").length);
  const ab = useComputed(() => allJobs.value.filter((j) => j.ats === "ashby").length);
  const wk = useComputed(() => allJobs.value.filter((j) => j.ats === "workable").length);

  return (
    <div class={`stats-grid${compact ? " stats-grid--compact" : ""}`}>
      <div class="stat-card">
        <span class="stat-label">Jobs Loaded</span>
        <span class="stat-value">{total.value === 0 ? "—" : total.value}</span>
      </div>
      <div class="stat-card">
        <span class="stat-label">Companies</span>
        <span class="stat-value">{companies.value === 0 ? "—" : companies.value}</span>
      </div>
      <div class="stat-card">
        <span class="stat-label">Platform Mix (US Only)</span>
        <div class="stat-mix-container">
          <div class="stat-mix-row">
            <span style="color: var(--greenhouse)">Greenhouse</span>
            <span>{gh.value}</span>
          </div>
          <div class="stat-mix-row">
            <span style="color: var(--lever)">Lever</span>
            <span>{lv.value}</span>
          </div>
          <div class="stat-mix-row">
            <span style="color: var(--ashby)">Ashby</span>
            <span>{ab.value}</span>
          </div>
          <div class="stat-mix-row">
            <span style="color: var(--workable)">Workable</span>
            <span>{wk.value}</span>
          </div>
        </div>
      </div>
      <div class="stat-card stat-card-wide">
        <span class="stat-label">Daily New Jobs (Past 14 Days)</span>
        <Sparkline />
      </div>
    </div>
  );
}
